export default {
  namespaced: true,
  state: () => ({
    isMaintenance: false,
  }),
  mutations: {
    setMaintenance(state, val) {
      state.isMaintenance = !!val
    },
  },
}
